import { all } from 'redux-saga/effects';
import { watcherLoginRequest } from './sagas/loginSaga';
import { watcherTableRequest } from './sagas/tableSaga';
import { watcherStartEditComponent } from './sagas/componentSaga';
import { watcherItemSaga } from './sagas/itemSaga';
import { watcherUISaga } from './sagas/uiSaga';
import { watcherComponentsRequest } from './sagas/componentsSaga';
import { watcherFileSaga } from './sagas/fileSaga';

export default function* rootSaga() {
  yield all([
    watcherLoginRequest(),
    watcherTableRequest(),
    watcherStartEditComponent(),
    watcherItemSaga(),
    watcherUISaga(),
    watcherComponentsRequest(),
    watcherFileSaga(),
  ]);
}